import React, { Component } from 'react';
import Embed from '../Embed/Embed';
import Form from '../Form/Form';
import './App.css';

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeComponent: null,
    };
  }
  
  render() {
    return (
      <div className="App">
        { window.location.pathname.startsWith('/embed') ? <Embed /> : <Form /> }
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/App.js